export default __webpack_public_path__ + "static/media/starEmpty.5f1b2455.svg";